import * as React from "react";
import styled from "styled-components";

const StyledPanel = styled.div`
  padding: ${({ theme }) => theme.space[2]};
  border: ${({ theme }) => theme.borders[0]};
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: ${({ theme }) => theme.colors.white4};
  backdrop-filter: ${({ theme }) => theme.backdropFilters.default};
`;

const StyledPanelHeader = styled.div<IPanelHeaderProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => `${theme.radii[1]} ${theme.radii[1]} 0 0`};
  background-color: transparent;
  color: ${({ theme }) => theme.colors.white};
`;

const PanelHeading = styled.h4`
  flex: 1;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes[5]};
  color: inherit;
  font-family: ${({ theme }) => theme.fonts.base};
`;

const StyledPanelFooter = styled.div`
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[2]}`};
`;

interface IPanelHeaderProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
}

const PanelHeader: React.FC<IPanelHeaderProps> = ({ children, title }) => (
  <StyledPanelHeader>
    <PanelHeading>{title}</PanelHeading>
    {children}
  </StyledPanelHeader>
);

interface IPanelBodyProps {
  children: React.ReactNode;
}

const PanelBody: React.FC<IPanelBodyProps> = ({ children }) => (
  <div>{children}</div>
);

interface IPanelFooterProps {
  children: React.ReactNode;
}

const PanelFooter: React.FC<IPanelFooterProps> = ({ children }) => (
  <StyledPanelFooter>{children}</StyledPanelFooter>
);

interface IPanelProps {
  children?: React.ReactNode;
}

const Panel = ({ children }: IPanelProps) => {
  return <StyledPanel>{children}</StyledPanel>;
};

Panel.Header = PanelHeader;
Panel.Body = PanelBody;
Panel.Footer = PanelFooter;

export default Panel;
